import { render, staticRenderFns } from "./detail-contents.vue?vue&type=template&id=f04e9d20&lang=pug&"
import script from "./detail-contents.vue?vue&type=script&lang=js&"
export * from "./detail-contents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports